import moment from 'moment';

export default function convert(dateString) {
  moment.locale('is');
  return dateString ? moment(dateString).format('DD. MM. YYYY') : '';
}

export function dateTime(dateString) {
  moment.locale('is');
  return dateString ? moment(dateString).format('D.M.YYYY HH:mm') : '';
}

export function convertToDate(dateString) {
  moment.locale('en');
  return dateString ? moment(dateString).toDate() : '';
}

export function convertTime(dateString) {
  moment.locale('is');
  return dateString ? moment(dateString).format('HH:mm') : '';
}

export function duration(hours) {
  moment.updateLocale('is', { relativeTime: { h: '1 klukkustund' } });
  moment.locale('is');
  moment.relativeTimeThreshold('h', 2000);
  return hours > 0 ? moment.duration(hours, 'hours').humanize() : '';
}

export function fromNow(date) {
  moment.locale('is');
  return moment(date).fromNow(true);
}

export function fromNowExact(date) {
  moment.locale('is');
  const n = moment();
  const t = moment(date);
  let exact = '';
  const years = n.diff(t, 'years');
  if (years) {
    exact = `${years} ár `;
  }
  const months = n.subtract(years, 'years').diff(t, 'months');
  if (months) {
    exact += `${months} mánuð${months === 1 ? 'ur' : 'ir'} `;
  }
  const days = n.subtract(months, 'months').diff(t, 'days');
  if (days) {
    exact += `${days} dag${(days === 1 || days === 21 || days === 31) ? 'ur' : 'ar'} `;
  }
  return exact;
}

export function now(f) {
  return moment().format(f);
}

export const isPassed = a => new Date(a).getTime() < Date.now();
export const compare = (a, b) => new Date(a).getTime() > new Date(b).getTime();

export const fromNowLocale = (lang, yearMonthDays) => {
  const [years, months] = yearMonthDays.split(' - ');
  // translations
  const tYear = lang === 'is' ? 'ár' : 'year';
  const tYears = lang === 'is' ? 'ár' : 'years';
  const tMonth = lang === 'is' ? 'mánuður' : 'month';
  const tMonths = lang === 'is' ? 'mánuðir' : 'months';
  const tAnd = lang === 'is' ? ' og ' : ' and ';
  // string logic
  const yearsText = years ? `${years} ${years > 1 ? tYears : tYear}` : '';
  const and = years && months ? tAnd : '';
  const monthsText = months ? `${months} ${months > 1 ? tMonths : tMonth}` : '';
  return `${yearsText}${and}${monthsText}`;
};



// WEBPACK FOOTER //
// ./src/utils/dateTools.js